var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hover"},[_c('div',{staticClass:"baloon"},[_vm._t("default")],2),_c('div',{staticClass:"baloon-vertice"})])
}
var staticRenderFns = []

export { render, staticRenderFns }